import styled from "@emotion/styled";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  CircularProgress,
  Divider,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
// import { IconPlus } from "@tabler/icons-react";
// import { useCallback } from "react";
// import { useModal } from "mui-modal-provider";
// import AddPaymentsModal from "../AddPaymentsModal";
import Pagination from "../../../components/Pagination";
import SubCard from "../../../components/cards/SubCard";
import moment from "moment";
// import usePayment from "../../../../hooks/usePayment";
import { capitalizeFirstLetter } from "../../../../utils/capitalizeFirstLetter";
import React, { useCallback, useMemo, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import NoResultFound from "../../../components/NoResultFound";
import SendIcon from "@mui/icons-material/Send";
import useResendMail from "../../../../hooks/useResendMail";
import { useSnackbarHelper } from "../../../components/Snackbar";
import { useModal } from "mui-modal-provider";
import ResendMailConfirmation from "../../../components/ResendMailConfirmation";
import { IconPlus } from "@tabler/icons-react";
import AddPaymentMadeModal from "./AddPaymentMadeModal";
import usePayment from "../../../../hooks/usePayment";
import TableSkeleton from "../../../components/skeleton/TableSkeleton";

const CustomTableRow = styled(TableRow)(() => ({
  height: "50px",
}));

const CustomTableCell = styled(TableCell)(() => ({
  paddingTop: 0,
  width: 130,
  paddingBottom: 0,
  // fontSize: "15px",
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

const PaymentMade = ({
  caseData,
  caseId,
  totalAmount,
  isCaseClosed,
  // paymentScheduling,
}: any) => {
  const { showModal } = useModal();

  const {
    paymentScheduling,
    ispaymentSchedulRefetching,
    refetchCasePaymentScheduling,
  } = usePayment(caseId?.id);

  const isPaymentCompleted = useMemo(() => {
    return paymentScheduling?.payment?.every(
      (payment: any) => payment.isPaymentCompleted === true
    );
  }, [paymentScheduling]);
  const updatedData = useMemo(() => {
    return paymentScheduling?.payment?.at(-1); // at(-1) is a cleaner way to get last item
    //eslint-disable-next-line
  }, [paymentScheduling, ispaymentSchedulRefetching]);

  const handleAdd = useCallback(() => {
    const modal: any = showModal(AddPaymentMadeModal, {
      onClose: () => modal.hide(),
      data: updatedData,
      refetchCasePaymentScheduling: refetchCasePaymentScheduling,
      contactName:
        caseData?.contactId?.firstName + " " + caseData?.contactId?.lastName,
      clientEmail: caseData?.contactId?.email[0].email,
      clientZip: caseData?.contactId?.zip,
      caseId,
      // payment_spread:[],
      // refetchPayment:,
    });
    //eslint-disable-next-line
  }, [showModal, ispaymentSchedulRefetching, paymentScheduling]);

  const showSnackbar = useSnackbarHelper();
  const { resendSinglePayment } = useResendMail();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [paymentId, setPaymentId] = useState(null);
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setPage(0);
      setExpanded(isExpanded ? panel : false);
    };

  const handleResendSinglePayment = useCallback(
    (hiring: any, payment: any) => {
      const payload = {
        type: hiring?.type,
        totalAmount: hiring?.feeQuoted,
        totalPaidAmount: hiring?.totalPaidAmount,
        balance: Number(hiring?.feeQuoted) - Number(payment?.totalPaid),
        amountPaid: payment?.payment,
        accountHolderName:
          caseData?.contactId?.firstName + " " + caseData?.contactId?.lastName,
        accountHolderId: caseData?.contactId?.zip,
        recieptId: payment?.recieptId,
        paymentMethod: payment?.paidType || hiring?.type,
        entryMode: "Manual",
        paymentDate: payment?.paymentMadeDate,
        chequeNumber: payment?.chequeNumber,
        clientEmail: caseData?.contactId?.email[0].email,
      };
      const modal: any = showModal(ResendMailConfirmation, {
        onClose: () => modal.hide(),
        onSubmit: async () => {
          try {
            const result = await resendSinglePayment(payload);
            const message = result?.message || "Success";
            showSnackbar(message, "success");
          } catch (error: any) {
            const message =
              error?.response?.result?.message || "An error occurred";
            showSnackbar(message, "error");
          }
        },
        title: "Resend Mail",
        content: "Do you really want to resend this email?",
      });
    },
    [showModal, resendSinglePayment]
  );

  // const handleResendSinglePayment = useCallback(
  //   async (hiring: any, payment: any) => {
  //     try {
  //       setPaymentId(payment?._id);
  //       const payload = {
  //         type: hiring?.type,
  //         totalAmount: hiring?.feeQuoted,
  //         totalPaidAmount: hiring?.totalPaidAmount,
  //         balance: Number(hiring?.feeQuoted) - Number(payment?.totalPaid),
  //         amountPaid: payment?.payment,
  //         accountHolderName:
  //           caseData?.contactId?.firstName +
  //           " " +
  //           caseData?.contactId?.lastName,
  //         accountHolderId: caseData?.contactId?.zip,
  //         recieptId: payment?.recieptId,
  //         paymentMethod: hiring?.type,
  //         entryMode: "Manual",
  //         paymentDate: payment?.paymentMadeDate,
  //         chequeNumber: payment?.chequeNumber,
  //         clientEmail: caseData?.contactId?.email[0].email,
  //       };

  //       const response = await resendSinglePayment(payload);

  //       const message = response?.message;
  //       showSnackbar(message, "success");
  //       if (response) {
  //         setPaymentId(null);
  //       }
  //     } catch (err: any) {
  //       setPaymentId(null);
  //       console.log(err?.response);
  //     }
  //   },
  //   //eslint-disable-next-line
  //   [caseData]
  // );

  if (ispaymentSchedulRefetching) {
    return <TableSkeleton />;
  }
  return (
    <SubCard
      title={"Payments Made"}
      secondary={
        isCaseClosed || isPaymentCompleted ? (
          <Tooltip
            title={
              isCaseClosed
                ? "Disabled because case is closed."
                : "Disabled because no payment schedule or pending installments exist."
            }
          >
            <span>
              <Button
                sx={{ color: "green", cursor: "pointer" }}
                disabled
                onClick={handleAdd}
              >
                <IconPlus />
              </Button>
            </span>
          </Tooltip>
        ) : (
          <Button
            sx={{ color: "green", cursor: "pointer" }}
            onClick={handleAdd}
          >
            <IconPlus />
          </Button>
        )
        // <Button
        //   sx={{
        //     color: "green",
        //     cursor: "pointer",
        //   }}
        //   disabled={isCaseClosed || isPaymentCompleted}
        //   onClick={handleAdd}
        // >
        //   <IconPlus />
        // </Button>
      }
    >
      {!!paymentScheduling?.payment?.length ? (
        paymentScheduling?.payment?.map((hiring: any, i: number) => {
          // const filteredPayments = hiring?.payment_spreads?.filter(
          //   (payment: any) => payment?.isPaid
          // );
          const allPaidPayments = [
            ...(hiring?.payment_spreads || []),
            ...(hiring?.manuallyAddedInstallment || []),
          ].filter((payment: any) => payment?.isPaid);

          // Optional: Sort by paymentMadeDate (descending or ascending)
          allPaidPayments.sort(
            (a, b) =>
              new Date(b?.paymentMadeDate).getTime() -
              new Date(a?.paymentMadeDate).getTime()
          );

          const paginatedPayments = allPaidPayments?.slice(
            page * rowsPerPage,
            page * rowsPerPage + rowsPerPage
          );

          // const count = allPaidPayments?.filter(
          //   (payment: any) => payment?.isPaid === true
          // );
          return (
            <Accordion
              expanded={expanded === `panel${i}`}
              onChange={handleChange(`panel${i}`)}
              key={i}
              elevation={0}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography
                  sx={{ width: "20%", flexShrink: 0, fontWeight: "bold" }}
                >
                  {/* {`Hiring ${i + 1}`} */}
                  Parole Eligibility Date
                </Typography>
                <Typography sx={{ width: "60%", flexShrink: 0 }}>
                  {moment(hiring?.paroleEligibilityDate).format("MM/DD/YYYY")}
                </Typography>
                <Typography>
                  Total ${Number(hiring?.totalPaidAmount).toFixed(2)}
                </Typography>
              </AccordionSummary>

              <AccordionDetails>
                <Divider />
                <TableContainer
                  key={hiring?._id}
                  sx={{ backgroundColor: "#d3d3d347", maxHeight: 305 }}
                >
                  <Table
                    sx={{ minWidth: 650, tableLayout: "fixed" }}
                    aria-label="simple table"
                  >
                    <TableHead>
                      <CustomTableRow>
                        <CustomTableCell>
                          <Typography variant="h5">Due Date</Typography>
                        </CustomTableCell>
                        <CustomTableCell>
                          <Typography variant="h5">Paid On</Typography>
                        </CustomTableCell>
                        {/* <CustomTableCell>
                          {" "}
                          <Typography variant="h5">Type</Typography>
                        </CustomTableCell> */}
                        <CustomTableCell>
                          {" "}
                          <Typography variant="h5">Payment Method</Typography>
                        </CustomTableCell>
                        <CustomTableCell>
                          {" "}
                          <Typography variant="h5">Paid by</Typography>
                        </CustomTableCell>
                        <CustomTableCell>
                          {" "}
                          <Typography variant="h5">Paid Type</Typography>
                        </CustomTableCell>
                        <CustomTableCell>
                          {" "}
                          <Typography variant="h5">Amount</Typography>
                        </CustomTableCell>
                      </CustomTableRow>
                    </TableHead>
                    <TableBody>
                      {/* {hiring?.totalPaidAmount === 0 && (
                        <CustomTableRow>
                          <CustomTableCell colSpan={5} align="center">
                            No payments available
                          </CustomTableCell>
                        </CustomTableRow>
                      )} */}
                      {allPaidPayments?.length ? (
                        paginatedPayments?.map((payment: any, index: number) =>
                          payment?.isPaid ? (
                            <CustomTableRow key={payment?._id}>
                              <CustomTableCell>
                                {payment?.dueDate
                                  ? moment(payment?.dueDate).format(
                                      "MM/DD/YYYY"
                                    )
                                  : "-"}
                              </CustomTableCell>
                              <CustomTableCell>
                                {moment(payment?.paymentMadeDate).format(
                                  "MM/DD/YYYY"
                                )}
                              </CustomTableCell>

                              {/* <CustomTableCell>
                                {capitalizeFirstLetter(hiring?.type)}
                              </CustomTableCell> */}

                              <CustomTableCell>
                                {capitalizeFirstLetter(
                                  payment?.transaction?.transaction_data?.method
                                    ?.type
                                ) ||
                                  capitalizeFirstLetter(
                                    payment?.paidType || hiring?.type
                                  )}
                              </CustomTableCell>
                              <CustomTableCell>
                                {capitalizeFirstLetter(payment?.paidBy)}
                              </CustomTableCell>
                              <CustomTableCell>
                                {payment?.isManuallyAddedInstallment
                                  ? "Manual"
                                  : "Scheduled"}
                              </CustomTableCell>
                              <CustomTableCell>
                                <Stack direction={"row"} alignItems={"center"}>
                                  <Typography minWidth={"60px"}>
                                    $ {Number(payment?.payment)?.toFixed(2)}
                                  </Typography>
                                  {!payment?.isManuallyAddedInstallment && (
                                    <Typography>
                                      {paymentId === payment?._id ? (
                                        <IconButton
                                          sx={{ cursor: "default" }}
                                          disableRipple
                                        >
                                          <CircularProgress
                                            size="25px"
                                            // sx={{ ml: 1 }}
                                          />
                                        </IconButton>
                                      ) : payment?.payment > 0 ? (
                                        <Tooltip
                                          title={
                                            "Resend Payment Confirmation Email"
                                          }
                                        >
                                          <IconButton
                                            onClick={() =>
                                              handleResendSinglePayment(
                                                hiring,
                                                payment
                                              )
                                            }
                                            // disabled={isLoadingDocuSignMail}
                                          >
                                            <SendIcon
                                              fontSize="medium"
                                              style={{
                                                color: "#1976d2",
                                                marginLeft: 5,
                                              }}
                                            />
                                          </IconButton>
                                        </Tooltip>
                                      ) : (
                                        ""
                                      )}
                                    </Typography>
                                  )}
                                </Stack>
                              </CustomTableCell>
                            </CustomTableRow>
                          ) : (
                            ""
                          )
                        )
                      ) : (
                        <CustomTableRow>
                          <CustomTableCell colSpan={5} align="center">
                            No payments available
                          </CustomTableCell>
                        </CustomTableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Pagination
                  component="div"
                  count={allPaidPayments?.length || 0}
                  page={page}
                  setPage={setPage}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                  rowsPerPageOptions={[5, 10, 25]}
                />
              </AccordionDetails>
            </Accordion>
          );
        })
      ) : (
        <NoResultFound>No Payment found</NoResultFound>
      )}
    </SubCard>
  );
};

export default PaymentMade;
